import { EditorContextProvider } from '@wix/ambassador-devcenter-v1-component-type-data/types';
import { BuilderComponent } from '@wix/document-services-types';

import { IProcessManifestProps } from '../lifecycle';

import {
  createEditorPlatformManifestServicesError,
  EditorPlatformManifestServicesErrorCode,
} from '../errors';
import { AbstractComponentFlow } from './AbstractComponentFlow';
import {
  ManifestComponentExtensionType,
  ProviderManifestStore,
} from '../stores';

export class EditorContextProviderFlow extends AbstractComponentFlow<ProviderManifestStore> {
  static extensionType =
    ManifestComponentExtensionType.CONTEXT_PROVIDER as const;
  public readonly type = EditorContextProviderFlow.extensionType;

  async loadManifest({
    appDataComponent,
    isPendingApplication,
  }: IProcessManifestProps) {
    const builderComponent = appDataComponent as BuilderComponent;
    const manifest = builderComponent.data as EditorContextProvider;

    if (!manifest.type) {
      throw createEditorPlatformManifestServicesError(
        EditorPlatformManifestServicesErrorCode.ManifestComponentTypeMissing,
      ).withComponentType(
        (builderComponent as any).appComponent?.id ||
          (builderComponent as any).id ||
          'unknown_id',
      );
    }

    const compType = manifest.type;
    if (manifest) {
      this.manifestStore.setManifest(
        compType,
        ManifestComponentExtensionType.CONTEXT_PROVIDER,
        manifest,
        null,
        isPendingApplication,
      );
    }
  }

  async loadPanels({ appDataComponent }: IProcessManifestProps) {
    console.log('there are no panels for editor context provider');
  }

  getCompTypes({ appDataComponent }: IProcessManifestProps): string[] {
    // @ts-expect-error type is missing in the AppDataComponent data type
    return [appDataComponent.data?.type];
  }
}
